import styled from 'styled-components';
import propTypes from 'prop-types';

const StyledFutureFunctionality = styled.div`
  height: 100%;
  text-align: center;
  padding-top: 25%;
  font-size: 32px;
`;

const FutureFunctionality = ({ pageName }) => (
  <StyledFutureFunctionality>
    Future Functionality
    <div>Page: {pageName}</div>
  </StyledFutureFunctionality>
);

FutureFunctionality.propTypes = {
  pageName: propTypes.string,
};

FutureFunctionality.defaultProps = {
  pageName: '',
};
export default FutureFunctionality;
